
  import { mapGetters } from 'vuex';
  import { titleize } from 'inflected';

  export default {
    data () {
      return {
        selectedTab: ''
      };
    },
    computed: {
      ...mapGetters('products', { comparison: 'getComparison', mortgage: 'get' }),
      tabs () {
        if (this.mortgage.rate_type === 'FIX') {
          return ['fixed-period-summary', 'full-term-costing', 'payments-schedule'];
        } else {
          return ['variable-rate-summary', 'payments-schedule'];
        }
      }
    },
    mounted () {
      this.selectedTab = this.tabs[0];
    },
    methods: {
      tabToText (tab) {
        return titleize(tab);
      }
    }
  };
